import { render } from "./OlapSidebar.vue?vue&type=template&id=11bd05de&ts=true"
import script from "./OlapSidebar.vue?vue&type=script&lang=ts"
export * from "./OlapSidebar.vue?vue&type=script&lang=ts"

import "./OlapSidebar.vue?vue&type=style&index=0&id=11bd05de&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__